/**
 * The wordmark as a real SVG: "THEVISI·O·NQC" in caps, the O of "VISION" held in
 * a viewfinder — four corner brackets, the way a detector frames what it found.
 * Caps make the O a full, round target the frame reads clearly around, where the
 * small lowercase o crowded its neighbours.
 *
 * The O gets a clear gap on both sides (the tspans jump by GAP) so the viewfinder
 * never touches the letters beside it. Colour follows context: the ink of
 * "THE/QC" is `currentColor` (dark on light cards, white in the dark rail), and
 * "VISION" plus the brackets take the accent.
 *
 * Coordinates are the raw Inter measurement at font-size 200, baseline y=200:
 * "THEVISI" ends at x≈807, the O advances ~155 (cap height ≈52→203), "NQC" is
 * the tail. The viewBox is cropped to the glyph band so the mark fills its height.
 */
export function Wordmark() {
  const GAP = 42;
  const oStart = 807.2 + GAP; // 849.2
  const oEnd = oStart + 154.6; // 1003.8
  const nStart = oEnd + GAP; // 1045.8
  // Viewfinder box around the O and the length of each corner arm.
  const x0 = oStart - 22, y0 = 42, x1 = oEnd + 22, y1 = 212, L = 48;
  return (
    <svg
      className="wm"
      viewBox="0 30 1512 222"
      role="img"
      aria-label="thevisionqc"
      fill="none"
    >
      <text
        y="200"
        fontFamily="'Inter Variable', 'Inter', sans-serif"
        fontSize="200"
        fontWeight="800"
        letterSpacing="0"
      >
        <tspan x="0" fill="currentColor">THE</tspan>
        <tspan fill="var(--accent)">VISI</tspan>
        <tspan x={oStart} fill="var(--accent)">O</tspan>
        <tspan x={nStart} fill="var(--accent)">N</tspan>
        <tspan fill="currentColor">QC</tspan>
      </text>
      <g
        stroke="var(--accent)"
        strokeWidth="15"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <path d={`M${x0},${y0 + L} V${y0} H${x0 + L}`} />
        <path d={`M${x1 - L},${y0} H${x1} V${y0 + L}`} />
        <path d={`M${x1},${y1 - L} V${y1} H${x1 - L}`} />
        <path d={`M${x0 + L},${y1} H${x0} V${y1 - L}`} />
      </g>
    </svg>
  );
}
